import Image from 'next/image';
import Badge from '@/components/shared/badge';
import { DotBlockEditor } from '@/components/shared/decodeTextBlock';

function HowItWorksSection({ title, eyebrow, bodyAlt, image, featuresList }) {
    const imgSrc = image?.fileAsset?.idPath;

    return (
        <section className="container py-16 lg:py-24" data-component="how-it-works-section">
            <div className="grid grid-cols-1 gap-12 lg:grid-cols-[3fr_2fr] lg:gap-16">
                {/* Left column: eyebrow, title, body, image */}
                <div className="flex flex-col gap-8">
                    {eyebrow && (
                        <div className="mb-2">
                            <Badge>{eyebrow}</Badge>
                        </div>
                    )}
                    {title && (
                        <h2 className="text-3xl font-bold leading-tight text-slate-900 lg:text-4xl">
                            {title}
                        </h2>
                    )}
                    {bodyAlt && <p className="text-base text-slate-600">{bodyAlt}</p>}
                    {imgSrc ? (
                        <div className="relative aspect-video overflow-hidden rounded-2xl">
                            <Image
                                src={imgSrc}
                                alt={title ?? 'How it works'}
                                fill
                                className="object-cover"
                                sizes="(max-width: 1024px) calc(100vw - 32px), calc(50vw - 64px)"
                            />
                        </div>
                    ) : (
                        <div className="flex aspect-video items-center justify-center rounded-2xl bg-slate-100">
                            <span className="text-xs font-semibold uppercase tracking-widest text-slate-400">
                                Placeholder for image
                            </span>
                        </div>
                    )}
                </div>

                {/* Right column: numbered feature cards */}
                {Array.isArray(featuresList) && featuresList.length > 0 && (
                    <div className="flex flex-col gap-3">
                        {featuresList.map((item, index) => (
                            <div
                                key={item?.identifier ?? index}
                                className="flex gap-3 rounded-xl border border-slate-200 bg-white p-4">
                                <div className="flex size-7 shrink-0 items-center justify-center rounded-full bg-slate-900 text-xs font-bold text-white">
                                    {index + 1}
                                </div>
                                <div className="flex flex-col gap-0.5">
                                    {item?.title && (
                                        <p className="text-sm font-bold text-slate-900">
                                            {item.title}
                                        </p>
                                    )}
                                    {item?.description && (
                                        <div className="prose max-w-none prose-p:text-xs prose-p:text-slate-600 prose-p:last:mb-0 prose-p:empty:hidden prose-a:text-fuschia-700">
                                            <DotBlockEditor blocks={item.description} />
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </section>
    );
}

export default HowItWorksSection;
